import axios from "axios";
import URLS from "../../util/urls.js";

function getListaImoveis(listaDestaques) {
  return listaDestaques.map(item => item.imovel);
}

const state = {
  listaDestaquesPrincipais: [],

  listaImagensCarrossel: [],

  legendaQuantidadeImoveisAluguelDestacados: '',
  legendaQuantidadeImoveisVendaDestacados: '',
};

const mutations = {
  atualizarListaDestaquesPrincipais(state, payload) {
    state.listaDestaquesPrincipais = payload;
  },
  atualizarListaImagensCarrossel(state, payload) {
    state.listaImagensCarrossel = payload;
  },

  atualizarLegendaQuantidadeImoveisAluguelDestacados(state, destaques) {
    const quantidade = destaques.filter(destaque => destaque.imovel.operacao === 'ALUGUEL').length;

    switch(quantidade) {
      case 0:
        state.legendaQuantidadeImoveisAluguelDestacados = 'Nenhum Imóvel de Aluguel Destacado';
        break;
      case 1:
        state.legendaQuantidadeImoveisAluguelDestacados = '1 Imóvel de Aluguel Destacado';
        break;
      default:
        state.legendaQuantidadeImoveisAluguelDestacados = `${quantidade} Imóveis de Aluguel Destacados`;
    }
  },
  atualizarLegendaQuantidadeImoveisVendaDestacados(state, destaques) {
    const quantidade = destaques.filter(destaque => destaque.imovel.operacao === 'VENDA').length;

    switch(quantidade) {
      case 0:
        state.legendaQuantidadeImoveisVendaDestacados = 'Nenhum Imóvel de Venda Destacado';
        break;
      case 1:
        state.legendaQuantidadeImoveisVendaDestacados = '1 Imóvel de Venda Destacado';
        break;
      default:
        state.legendaQuantidadeImoveisVendaDestacados = `${quantidade} Imóveis de Venda Destacados`;
    }
  },
};

const actions = {
  recuperarDestaquesPrincipais(context, payload) {
    return axios.post(URLS.DESTAQUES_SITE_RECUPERAR_DESTAQUES_PRINCIPAIS, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SESSAO_EXPIRADA":
            return context.dispatch("loginStore/relogar", {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch("recuperarDestaquesPrincipais", payload);
                }
              }).catch((error) => {
                throw error;
              });
          case "SUCESSO": {
            const payload = getListaImoveis(response.data.lista);
            context.commit("atualizarListaDestaquesPrincipais", payload);
            context.commit("atualizarLegendaQuantidadeImoveisAluguelDestacados", response.data.lista);
            context.commit("atualizarLegendaQuantidadeImoveisVendaDestacados", response.data.lista);
            
            return response.data;
          }
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  gravarDestaquePrincipal(context, payload) {
    return axios.post(URLS.DESTAQUES_SITE_GRAVAR_DESTAQUE_PRINCIPAL, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SESSAO_EXPIRADA":
            return context.dispatch("loginStore/relogar", {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch("gravarDestaquePrincipal", payload);
                }
              }).catch((error) => {
                throw error;
              });
          case "SUCESSO": {
            const payload = getListaImoveis(response.data.lista);
            context.commit("atualizarListaDestaquesPrincipais", payload);
            context.commit("atualizarLegendaQuantidadeImoveisAluguelDestacados", response.data.lista);
            context.commit("atualizarLegendaQuantidadeImoveisVendaDestacados", response.data.lista);
            
            return response.data;
          }
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  removerDestaquePrincipal(context, payload) {
    return axios.post(URLS.DESTAQUES_SITE_REMOVER_DESTAQUE_PRINCIPAL, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SESSAO_EXPIRADA":
            return context.dispatch("loginStore/relogar", {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch("removerDestaquePrincipal", payload);
                }
              }).catch((error) => {
                throw error;
              });
          case "SUCESSO": {
            const payload = getListaImoveis(response.data.lista);
            context.commit("atualizarListaDestaquesPrincipais", payload);
            context.commit("atualizarLegendaQuantidadeImoveisAluguelDestacados", response.data.lista);
            context.commit("atualizarLegendaQuantidadeImoveisVendaDestacados", response.data.lista);
            
            return response.data;
          }
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  recuperarImagensImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch("recuperarImagensImovel", payload);
              }
            }).catch((error) => {
              throw error;
            });
        case "SUCESSO":
          return response.data.item.imagens;
        default:
          return response.data.item.imagens;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //IMAGENS
  uploadImagemCarrossel(context, payload) {
    return axios.post(URLS.IMAGENS_CARROSSEL_UPLOAD, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('uploadImagemCarrossel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  removerImagensCarrossel(context, payload) {
    return axios.post(URLS.IMAGENS_CARROSSEL_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerImagensCarrossel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarImagensCarrossel(context, payload) {
    return axios.post(URLS.IMAGENS_CARROSSEL_LISTAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit("atualizarListaImagensCarrossel", response.data.lista);
          return response.data.lista;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch("recuperarImagensCarrossel", payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data.lista;
      }
    }).catch((error) => {
      throw error;
    });
  },

  uploadImagemBannerQuemSomos(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_UPLOAD_BANNER_QUEM_SOMOS, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("uploadImagemBannerQuemSomos", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  uploadBannerImagemPrincipalView1(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_UPLOAD_BANNER_PRINCIPAL_VIEW_1, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("uploadBannerImagemPrincipalView1", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  uploadBannerImagemPrincipalView2(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_UPLOAD_BANNER_PRINCIPAL_VIEW_2, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("uploadBannerImagemPrincipalView2", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  removerImagemBannerQuemSomos(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_REMOVER_BANNER_QUEM_SOMOS, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("removerImagemBannerQuemSomos", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  removerImagemBannerPrincipalView1(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_REMOVER_BANNER_PRINCIPAL_VIEW_1, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("removerImagemBannerPrincipalView1", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  removerImagemBannerPrincipalView2(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_REMOVER_BANNER_PRINCIPAL_VIEW_2, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("removerImagemBannerPrincipalView2", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  }
};

export default {
  state,
  mutations,
  actions
}